import React from 'react';
import t from '@jetshop/intl';

import styled from 'react-emotion';

const ShortDescriptionWrapper = styled('div')`
  width: 100%;
  margin-bottom: 24px;
`;

const ShortDescriptionBlock = styled('div')`
  width: 100%;
  margin-bottom: 8px;
`;

const ReadMoreLink = styled('span')`
  cursor: pointer;
  text-decoration: underline;
`;

const ReadMore = ({
  textString,
  shortDescriptionLength,
  concatSymbol,
  readMoreAction
}) => {
  const shortDescriptionArray = textString && textString.split(' ');

  const shortDescritionLength =
    shortDescriptionArray &&
    (shortDescriptionArray.length > shortDescriptionLength
      ? shortDescriptionLength
      : shortDescriptionArray.length);
  const shortDescriptionArraySelected =
    shortDescriptionArray &&
    shortDescriptionArray.splice(0, shortDescritionLength);
  const shortDescription = shortDescriptionArraySelected
    ? shortDescriptionArraySelected.join(' ') + concatSymbol
    : '';

  return (
    <ShortDescriptionWrapper>
      <ShortDescriptionBlock
        dangerouslySetInnerHTML={{
          __html: shortDescription
        }}
      />

      <ReadMoreLink className="read-more" onClick={readMoreAction}>
        {t('Read more')}
      </ReadMoreLink>
    </ShortDescriptionWrapper>
  );
};

export default ReadMore;
